module.exports = __webpack_public_path__ + "static/media/SFProText-Medium.a260cbc1.ttf";